const scheduledServicesUsersList = {
  title: 'Accountables'
}

export default scheduledServicesUsersList;